/**
 * Hero Banner Component
 * Displays the banner image at the top of investor relations pages.
 */
import React from 'react'
import styled from '@emotion/styled'

const BannerWrapper = styled.section`
  position: relative;
  opacity: 0.99;
  width: 100%;
  aspect-ratio: 1920 / 403;
  min-height: 84px;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const bannerBaseUrl =
  'https://cdn.sanity.io/images/s1gua7do/production/0bb8a9c2a7a15bd63079e6c089096b9945eadeaf-1920x403.jpg'

const bannerSrc = `${bannerBaseUrl}?w=1920&h=403&auto=format`

const bannerSrcSet = [
  `${bannerBaseUrl}?rect=0,1,1920,402&w=320&h=67&auto=format 320w`,
  `${bannerBaseUrl}?rect=0,1,1920,402&w=654&h=137&auto=format 654w`,
  `${bannerBaseUrl}?w=768&h=161&auto=format 768w`,
  `${bannerBaseUrl}?rect=1,0,1919,403&w=1024&h=215&auto=format 1024w`,
  `${bannerBaseUrl}?rect=1,0,1918,403&w=1366&h=287&auto=format 1366w`,
  `${bannerBaseUrl}?rect=1,0,1919,403&w=1600&h=336&auto=format 1600w`,
  `${bannerBaseUrl}?w=1920&h=403&auto=format 1920w`,
].join(',\n')

const HeroBanner: React.FC = () => {
  return (
    <BannerWrapper>
      <img
        width="1920"
        height="403"
        sizes="(min-width: 1920px) 1920px, 100vw"
        decoding="async"
        src={bannerSrc}
        srcSet={bannerSrcSet}
        alt="Kidsland"
      />
    </BannerWrapper>
  )
}

export default HeroBanner
